module.exports = __webpack_public_path__ + "static/media/16_skf.2bc86653.svg";